import { PermissionsCategory } from "src/app/auth/permissions";

@PermissionsCategory("PostSchoolOutcomesPermissions")
export class PostSchoolOutcomesPermissions {
    static readonly None = 0;
    static readonly View = 1;
    static readonly EditEntryInputData = 2;
    static readonly EditExitInputData = 3;
    static readonly EditSurvey = 4;
}
